module.exports = __webpack_public_path__ + "static/media/data_contacts.263636f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/products/artist/assets/data_contacts.png
// module id = 256
// module chunks = 0